export default __webpack_public_path__ + "static/media/free_banner.c696be8f.jpg";